import { css } from "packages/styled-components";
import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";
import { setFlexFDC } from "theme/setter/setFlexValues/setFlexFDC";

const isFinOn = process.env.REACT_APP_FIN === "fin";
const finOn = css`
  margin: 10px 0 30vh 0;
`;
const sngb = css`
  margin: auto 0;
`;
export const SSignInForm = styled.form`
  ${isFinOn ? finOn : sngb};

  ${setFlexDFAIC};
  ${setFlexFDC};
`;
